export default __webpack_public_path__ + "media/trash-can.309d02d9.svg";